export default __webpack_public_path__ + "2e320b9bc16ab552a63dd599efb31d4c.png";